<template>
  <div>
    <!-- Tabla -->
    <div class="mt-2 hidden lg:block">
      <div
        class="min-w-full overflow-hidden overflow-x-auto align-middle shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Comprobante
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Descripción
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Vencimiento
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Monto
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Estado
              </th>

              <th
                class="bg-gray-50 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider text-gray-500"
              ></th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-200 bg-white">
            <tr v-for="(comprobante, index) in comprobantes" :key="index" class="bg-white">
              <td class="whitespace-nowrap px-6 py-4 text-left text-sm text-gray-500">
                {{ comprobante.numero_comprobante }}
              </td>

              <td class="px-6 py-4 text-left text-sm text-gray-500">
                {{ comprobante?.descripcion }}
              </td>

              <td class="whitespace-nowrap px-6 py-4 text-left text-sm text-gray-500">
                {{ comprobante?.fecha_vencimiento | myDate2 }}
              </td>

              <td class="whitespace-nowrap px-6 py-4 text-right text-sm text-gray-500">
                ${{ comprobante?.monto | myMoney }}
              </td>

              <td class="whitespace-nowrap px-6 py-4 text-center text-sm">
                <BadgeEstado
                  :estado="textoEstado(comprobante.estado)"
                  :classEstado="classEstado(comprobante.estado)"
                  :showWarning="comprobante.adherido_pago_directo"
                />
              </td>

              <td class="whitespace-nowrap px-6 py-4 text-right text-sm">
                <button
                  v-if="!comprobante.estado || comprobante.estado.estado.habilita_pago"
                  @click="
                    $router.push({
                      name: 'formulario-comprobante',
                      params: { idFormulario: 'caja-form', comprobante: comprobante },
                    })
                  "
                  class="inline-flex items-center justify-center space-x-2 rounded-md border border-blue-brand-700 bg-blue-brand-500 px-2 py-1.5 text-blue-brand-100 transition duration-150 ease-in-out hover:bg-blue-brand-700 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-700"
                >
                  <span class="text-center text-sm font-bold">Pagar</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Cards -->
    <div class="grid gap-3 lg:hidden">
      <div
        v-for="(comprobante, index) in comprobantes"
        :key="index"
        class="flex items-center rounded-lg border-2 border-gray-200 bg-white p-4 md:justify-center md:px-0"
      >
        <div class="mx-auto flex flex-1 flex-col items-center justify-around space-y-4">
          <div class="space-y-2 text-center">
            <div>
              <p class="text-sm font-bold tracking-wide text-gray-600">
                Comprobante: {{ comprobante.numero_comprobante }}
              </p>
            </div>

            <div>
              <p class="text-base font-medium text-gray-600">
                Descripción: {{ comprobante.descripcion }}
              </p>
            </div>

            <div>
              <p class="text-base font-medium text-gray-600">
                Monto: ${{ comprobante.monto | myMoney }}
              </p>
            </div>

            <div>
              <p class="text-base font-medium text-gray-600">
                Vencimiento: {{ comprobante.fecha_vencimiento | myDate2 }}
              </p>
            </div>

            <div>
              <p class="inline-flex items-center space-x-1 text-base font-medium text-gray-600">
                <span>Estado:</span>
                <BadgeEstado
                  :estado="textoEstado(comprobante.estado)"
                  :classEstado="classEstado(comprobante.estado)"
                  :showWarning="comprobante.adherido_pago_directo"
                />
              </p>
            </div>

            <div>
              <p class="text-base font-medium text-gray-600">
                <button
                  @click="
                    $router.push({
                      name: 'formulario-comprobante',
                      params: { idFormulario: 'caja-form', comprobante: comprobante },
                    })
                  "
                  class="inline-flex items-center justify-center space-x-2 rounded-md border border-blue-brand-700 bg-blue-brand-500 px-2 py-1.5 text-blue-brand-100 transition duration-150 ease-in-out hover:bg-blue-brand-700 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-700"
                >
                  <span class="text-center text-sm font-bold">Pagar</span>
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useAcreditacionRolNotario, useAcreditacionServicio, useSession } from '@colescba/ui'

import Swal from 'sweetalert2'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import { mapActions, mapState } from 'vuex'

const BadgeEstado = {
  props: {
    estado: { type: String, required: true },
    classEstado: { type: Object, required: true },
    showWarning: { type: Boolean, required: false },
  },

  render() {
    if (!this.showWarning) {
      return (
        <span class={`rounded-lg px-2 py-0.5 text-center font-medium ${this.classEstado.text}`}>
          {this.estado}
        </span>
      )
    } else {
      return (
        <span class="inline-flex h-6 items-center lg:h-5">
          <SolidExclamationCircleIcon
            data-tippy-content="Adherido a débito automático"
            class={`h-full rounded-l-lg p-0.5 outline-none ${this.classEstado.warning}`}
          />
          <span class={`h-full rounded-r-lg px-2 text-center font-medium ${this.classEstado.text}`}>
            {this.estado}
          </span>
        </span>
      )
    }
  },
}

export default {
  name: 'ListaComprobantes',

  props: ['comprobantes'],

  mixins: [
    useService('portalPagos'),
    useSession(),
    useAcreditacionServicio(),
    useAcreditacionRolNotario(),
  ],

  components: { BadgeEstado },

  mounted() {
    this.$nextTick(() => tippy('[data-tippy-content]'))
  },

  computed: {
    ...mapState(['saldo']),
  },

  methods: {
    ...mapActions(['actualizarSaldo']),

    async pagarComprobante(comprobante) {
      await this.actualizarSaldo({
        cuitCuil: this.notario.cuitCuil,
        cuentaNotarial: this.cuentaNotarial,
      })

      if (this.saldo < comprobante.monto) {
        return Swal.fire({
          html: `
              <div class="flex justify-center">
                <svg class="w-16 h-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
              </div>
              <div class=" text-gray-500 text-base text-center font-bold">
                No es posible realizar el pago.
              </div>
              <div class="text-gray-500 text-base text-center">
                Saldo insuficiente.
              </div>
            `,
          confirmButtonText: `Aceptar`,
          buttonsStyling: false,
          customClass: {
            confirmButton:
              'mx-2 px-4 py-2 text-base font-medium text-blue-brand-100 transition duration-150 ease-in-out bg-blue-brand-500 border border-blue-brand-700 rounded-md shadow-sm hover:bg-blue-brand-700 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-700 sm:text-sm',
          },
        })
      }
      let warningDebitoAutomatico = ''
      if (comprobante.adherido_pago_directo) {
        warningDebitoAutomatico = `
          <div class="p-3 mt-2 flex w-full items-center space-x-2 border border-gray-50 shadow-sm rounded-full text-gray-500">
            <svg class="w-20 p-2 text-white bg-gradient-radial from-amber-400 rounded-full" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            <div class="text-base text-left">Recuerde que el comprobante se encuentra <span class="font-semibold">adherido al débito automático</span>.</div>
          </div>
          `
      }
      Swal.fire({
        html: `
          <div class=" text-gray-500 text-base text-center">
            ¿Desea pagar el comprobante ${comprobante.numero_comprobante}?
          </div>
          <div class="text-gray-500 text-base text-center">
            Se descontará <span class="font-bold">$${this.$options.filters.myMoney(
              comprobante.monto
            )}</span> del saldo de su cuenta notarial.
          </div>
          ${warningDebitoAutomatico}
          `,
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
        buttonsStyling: false,
        customClass: {
          confirmButton:
            'mx-2 px-4 py-2 text-base font-medium text-blue-brand-100 transition duration-150 ease-in-out bg-blue-brand-500 border border-blue-brand-700 rounded-md shadow-sm hover:bg-blue-brand-700 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-700 sm:text-sm',
          cancelButton:
            'mx-2 px-4 py-2 text-base font-medium text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm hover:bg-cool-gray-200 focus:outline-none focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-cool-gray-200 sm:text-sm',
        },
      }).then(result => {
        if (result.isConfirmed) {
          this.cuentaNotarial
            .postDeuda(this.notario.cuitCuil, {
              tipo: comprobante.categoria.id.trim(),
              numero_comprobante: comprobante.numero_comprobante,
              medios_pago: ['CTANOT'],
            })
            .then(() => {
              this.$toast.open({
                message: 'La solicitud de pago ingresó correctamente y se procesará en breve',
                type: 'success',
                duration: 2500,
                dismissible: true,
              })
              this.$emit('refresh-comprobantes')
            })
            .catch(e => {
              this.$toast.open({
                message: 'Ocurrió un error al generar la solicitud de pago',
                type: 'error',
                duration: 20000,
                dismissible: true,
              })
            })
        }
      })
    },
    textoEstado(estado) {
      if (!estado) return 'Disponible para el pago'
      return estado.detalle
        ? estado.detalle.mensaje.capitalizeOnlyFirst()
        : estado.estado.id.capitalizeOnlyFirst()
    },
    classEstado(estado) {
      let estadoId = estado?.estado?.id.trim() || ''
      switch (estadoId) {
        case 'PAGADO':
          return {
            text: 'bg-green-200 text-green-600',
            warning: 'bg-green-600 text-white',
          }
        case 'PAGO_PROCESADO':
          return {
            text: 'bg-green-200 text-green-600',
            warning: 'bg-green-600 text-white',
          }
        case 'CREADO':
          return {
            text: 'bg-gray-200 text-gray-600',
            warning: 'bg-gray-600 text-white',
          }
        case 'PUBLICADO':
          return {
            text: 'bg-blue-200 text-blue-600',
            warning: 'bg-blue-600 text-white',
          }
        case 'PAGO_EN_PROCESO':
          return {
            text: 'bg-amber-200 text-amber-600',
            warning: 'bg-amber-600 text-white',
          }
        case 'ERROR_PAGO':
          return {
            text: 'bg-red-200 text-red-600',
            warning: 'bg-red-600 text-white',
          }

        case 'PAGO_RECHAZADO':
          return {
            text: 'bg-red-200 text-red-600',
            warning: 'bg-red-600 text-white',
          }
        case 'PAGO_INVIABLE':
          return {
            text: 'bg-red-200 text-red-600',
            warning: 'bg-red-600 text-white',
          }
        case 'DEVUELTO':
          return {
            text: 'bg-violet-200 text-violet-600',
            warning: 'bg-violet-600 text-white',
          }
        case 'VENCIDO':
          return {
            text: 'bg-orange-200 text-orange-600',
            warning: 'bg-orange-600 text-white',
          }
        case 'ANULADO':
          return {
            text: 'bg-rose-200 text-rose-600',
            warning: 'bg-rose-600 text-white',
          }
        default:
          return {
            text: 'bg-green-200 text-green-600',
            warning: 'bg-green-600 text-white',
          }
      }
    },
  },
}
</script>
